import {
  Button,
  darken,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import { colors } from '../../../themes';

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

export const InvalidStatusTransitionModal: React.FC<Props> = ({
  open,
  message,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      className={classes.dialog}
    >
      <DialogTitle disableTypography className={classes.header}>
        <span>Action Not Allowed</span>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.main}>
        <div className="dialog-text">{message}</div>
        <div className={classes.actions}>
          <Button className={classes.okBtn} onClick={onClose}>
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paperWidthXs': { maxWidth: 400 },
  },
  header: {
    fontSize: 18,
    color: '#4f4f4f',
    fontWeight: 700,
    textAlign: 'center',
    padding: theme.spacing(1.5),
    textTransform: 'uppercase',
  },
  main: {
    padding: theme.spacing(1, 2),
    '& .dialog-text': {
      textAlign: 'center',
      fontSize: 15,
      padding: theme.spacing(1, 0),
      color: '#4f4f4f',
    },
  },
  actions: {
    alignItems: 'center',
    borderTop: '1px solid #bdbdbd',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 0),
  },
  okBtn: {
    backgroundColor: colors.textPrimary[400],
    color: 'white',
    borderRadius: 5,
    padding: theme.spacing(0.8, 4),
    '&:hover': { backgroundColor: darken(colors.textPrimary[400], 0.15) },
  },
}));

export default React.memo(InvalidStatusTransitionModal);
